import StackedColumn from './ChartsStackedColumn';
import StackedColumnWithLine from './ChartsStackedColumnWithLine';
import GroupedBar from './ChartsGroupedBar';

export default {
  stackedColumn: StackedColumn,
  stackedColumnWithLine: StackedColumnWithLine,
  groupedBar: GroupedBar,
};
